"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constant = require("../constant");
var getColor = function getColor(color) {
  switch (color) {
    case _constant.colorsEnum.ORANGE:
      return _constant.colors.ORANGE;
    case _constant.colorsEnum.VIOLET:
      return _constant.colors.VIOLET;
    case _constant.colorsEnum.BLUE:
      return _constant.colors.BLUE;
    case _constant.colorsEnum.LIGHT_BLUE:
      return _constant.colors.LIGHT_BLUE;
    case _constant.colorsEnum.GREEN:
      return _constant.colors.GREEN;
    case _constant.colorsEnum.LIGHT_GREEN:
      return _constant.colors.LIGHT_GREEN;
    case _constant.colorsEnum.GREY:
      return _constant.colors.GREY;
    default:
      return _constant.colors.H_DARK;
  }
};
var _default = getColor;
exports.default = _default;